export default {
  title: 'Seuraa tilaustasi',
  text: 'Kiitos, että tilasit meiltä! <0>{{carrier}}</0>-kumppanuutemme ansiosta voimme hoitaa toimitukset suoraan sivustollamme, mikä säästää meille keskimäärin {{savings}} toimituspalkkioissa. Tilauksesi toimittaa <1>{{carrier}}</1>, mikä takaa erinomaisen palvelun 😊',
  labels: {
    delivered_by: 'Toimittaja',
  },
  buttons: {
    track_order: 'Seuraa tilauksen tilaa reaaliajassa →',
    track_order_once_confirmed: 'Seuraa tilauksen tilaa reaaliajassa kun se on vahvistettu',
  },
};
